/*
 *    Copyright (c) 2018-2025, binsoo All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright
 * notice, this list of conditions and the following disclaimer in the
 * documentation and/or other materials provided with the distribution.
 * Neither the name of the www.gac-nio.com developer nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 * Author: binsoo (chenfengbin@gac-nio.com)
 */

/**
 *
 * http配置
 *
 */

import axios from "axios";
import md5 from "blueimp-md5";
import { getToast } from "@/components/popup";
import { v4 as uuidv4 } from "uuid"

const ERROR_CODE = {
  UNAUTHORIZED: 401
}

// 超时时间
axios.defaults.timeout = 30000;
// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true;

axios.defaults.baseURL = process.env.VUE_APP_axiosURL;

// TODO signAppSecurity没有放到.env.[model]维护原因如下: 220607 .env.[model]不支持$符号
let securityStr
if (process.env.VUE_APP_ENV !== 'prd') {
  securityStr = 'h5*^&%w$#'
} else {
  securityStr = 'h5-prd*2^3&$%5w78@#'
}

const SIGN = {
  signAppId: process.env.VUE_APP_signAppId,
  signAppSecurity: securityStr,
};

function createReq(method, path) {
  if (typeof method !== 'string') {
    return ''
  }
  method = method.toUpperCase()

  return (method + path) || ''
}

function createSign(params = {}) {
  let data = {
    signAppId: SIGN.signAppId,
    ...params,
  }
  let paramsArr = []
  for (let k in data) {
    paramsArr.push(`${k}=${data[k]}`)
  }
  paramsArr.sort((a, b) => {
    return (a + '').localeCompare(b + '')
  })
  // console.log(paramsArr)
  return paramsArr.join('&');
}

function fmtSign ({method, path, params} = {}) {
  let str = createReq(method, path) + '?' + createSign(params) + SIGN.signAppSecurity + 'signsh';
  return md5(str)
}

let lockToast = false;

// NProgress.configure({ showSpinner: false })// NProgress Configuration
// HTTPrequest拦截
axios.interceptors.request.use(
  config => {
    // NProgress.start() // start progress bar
    // if (!config.headers["Authorization"])
    //   config.headers["Authorization"] =
    //     "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJtc2ciOiJzdWNjZXNzIiwibGljZW5zZSI6Im1hZGUgYnkgZ2FjLW5pbyIsImNvZGUiOjAsImRhdGEiOm51bGwsInVzZXJfbmFtZSI6IjEzNDAxMDI5Mjg1MTU1NTIxNTMxNzEyMiIsInNjb3BlIjpbInNlcnZlciJdLCJleHAiOjE1NjQ0OTY4NzMsInVzZXJJZCI6MTU1LCJhdXRob3JpdGllcyI6WyJST0xFX1VTRVIiLCJhcHBfc3Bfcm9sZSJdLCJqdGkiOiIxYTVhODA0ZS0xZWFiLTQ1YWYtOGRhMy1kZTlkM2EwYjY3MWYiLCJjbGllbnRfaWQiOiJ3ZWl4aW4tY2xpZW50In0.G3BoT2-qfLDVPdN1hnDVvx9WXGQbGiQbtkC4-ew4dCs"; // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
    if (config.headers["Authorization"] == "null") {
      delete config.headers.Authorization;
    }
    let appTimestamp = Date.parse(new Date())/1000;
    let appRequestId = uuidv4();
    let params = {
      method: config.method,
      path: config.url,
      params: {
        appTimestamp,
        appRequestId
      }
    }
    if (config.method === 'post') {
      let dataStr = JSON.stringify(config.data)
      // console.log(dataStr)
      params.params = {
        ...params.params,
        jsonBody: dataStr
      }
    } else {
      params.params = {
        ...params.params,
        ...config.params
      }
    }

    let sign = fmtSign(params)
    if (sign) {
      config.headers['signAppId'] = SIGN.signAppId
      config.headers['appTimestamp'] = appTimestamp
      config.headers['appRequestId'] = appRequestId
      config.headers['paramSign'] = sign
    }
    if (config.headers.noToast) {
      lockToast = true;
      let headers = config.headers;
      delete headers.noToast;
    };
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// HTTPresponse拦截
axios.interceptors.response.use(data => {
  ///NProgress.done()
  if (data.data.code !== 0) {
    if (!lockToast) {
      getToast().open({
        text: data.data.msg
      });
    }
    if (lockToast) {
      lockToast = false;
    }
    return Promise.reject(data);
  }
  return data;
}, error => {
  const errMsg = error.toString()
  const code = errMsg.substr(errMsg.indexOf('code') + 5)

  if (!lockToast) {
    if (parseInt(code) === ERROR_CODE.UNAUTHORIZED) {
      getToast().open({
        text: '请重新登录！'
      })
    } else {
      getToast().open({
        text: '服务器开小差了，请稍后再试'
      })
    }
  }

  if (lockToast) {
    lockToast = false;
  }

  return Promise.reject(error)
})

export default axios;
